var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export { PromotionType } from './PromotionType';
export { PromotionBillingPeriod } from './PromotionBillingPeriod';
export { PromotionStatus } from './PromotionStatus';
export default function (context) {
    context.registerService({
        name: 'IPromotionManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "PromotionManager" */ './PromotionManager');
            return new svc.PromotionManager(context);
        })
    });
    context.registerService({
        name: 'IPromotionQueryService',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "PromotionQueryService" */ './PromotionQueryService');
            return new svc.PromotionQueryService(context);
        })
    });
    context.registerService({
        name: 'IPromotionSearchService',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "PromotionSearchService" */ './PromotionSearchService');
            return new svc.PromotionSearchService(context);
        })
    });
}
//# sourceMappingURL=main.js.map